var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('co-button',{attrs:{"disabled":_vm.disabled,"self-class":_vm.disabled?'s-btn-disabled':'s-btn'},on:{"click":_vm.clickBtn}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }